import { ALL_SELECT_FILTER_ITEM } from '../../common/constants'

const DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS = {
  IS_CURATION_DONE: null,
  IS_QA_DONE: null,
  IS_QC_DONE: null,
  TASK_STATUS: ALL_SELECT_FILTER_ITEM.value,
  AUTOEAT_STATUS: ALL_SELECT_FILTER_ITEM.value,
  SEARCH: '',
  ASSIGNED_CURATOR: ALL_SELECT_FILTER_ITEM.value,
  ASSIGNED_QA: ALL_SELECT_FILTER_ITEM.value,
  ASSIGNED_QC: ALL_SELECT_FILTER_ITEM.value,
  DUPLICATE: null,
}

export default DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS
